import kasbon from '../views/kasbon/index.vue'
import kasbon_create from '../views/kasbon/create.vue'
import kasbon_edit from '../views/kasbon/edit.vue'
import kasbon_import from '../views/kasbon/import.vue'

const routes = [
  {
    path: "/kasbon",
    name: "kasbon",
    component: kasbon,
    meta: { authOnly: true },
  },
  {
    path: "/kasbon/create",
    name: "kasbon_create",
    component: kasbon_create,
    meta: { authOnly: true },
  },
  {
    path: "/kasbon/edit/:uuid",
    name: "kasbon_edit",
    component: kasbon_edit,
    meta: { authOnly: true },
  },
  {
    path: "/kasbon/import",
    name: "kasbon_import",
    component: kasbon_import,
    meta: { authOnly: true },
  },]

export default routes
